import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from '../entities/app-localization';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss'],
  standalone: false
})
export class AccessDeniedComponent implements OnInit {
  noAccess: boolean;
  appStrings: AppLocalization;

  constructor(
    private appInfoService: AppInfoService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.noAccess = Boolean(this.route.snapshot.paramMap.get('noAccess'));
    this.appStrings = this.appInfoService.appStrings;
  }
}
